<template>
  <div class="serviceWrap">
    <el-dialog class="dialogWrap" :title="$t('creation.select')" :visible.sync="visible" width="1020px" top="4vh">
      <p class="mb20">{{ $t("creation.warn") }}</p>
      <div class="bodyWrap">
        <el-row :gutter="16">
          <el-col
            :span="8"
            class="aloneWrap"
            :class="{
              aloneActive: selectedServiceIdList.includes(item.id),
              crna: requiredServiceCodeList.includes(item.serviceCode),
            }"
            v-for="item in serviceList"
            :key="item.id"
          >
            <div @click="clickHandle(item)">
              <el-card shadow="hover" class="hg294">
                <p class="tof02 upgradePrice">
                  <span class="fs13">{{ $t("creation.total") }}S$</span>
                  {{ serviceSinglePriceSum(item) }}
                </p>
                <p class="tof03 title">
                  {{ requiredServiceCodeList.includes(item.serviceCode) ? $t("common.required") : "" }}
                  {{ getLanguage == "zh" ? item.descriptionCn : item.description }}
                  <info-popover
                    placement="top"
                    :content="getLanguage == 'zh' ? item.serviceScopeCn : item.serviceScope"
                    iconClass="fs13 grey"
                    v-if="item.serviceScopeCn && item.serviceScope"
                  />
                </p>
                <p class="fs12 tof03">
                  <span class="fwb green fs12 el-icon-check"></span>
                  {{ getLanguage == "zh" ? item.descriptionCn : item.description }}
                  <span v-if="$isNumberLike(item.serviceFee)">({{ priceCurrencyFormat(item.serviceFee, item.currency) }})</span>
                </p>
                <!-- 第三方费用 -->
                <p class="fs12 mb2" v-if="item.thirdPartyFeeDescriptionCn && item.thirdPartyFeeDescription">
                  <span class="fwb green fs12 el-icon-check"></span>
                  {{ $t("creation.priceInclude") }}
                </p>
                <p class="fs12 tof03 thirdparty">
                  <span class="crgy9" v-if="getLanguage == 'zh' && item.thirdPartyFeeDescriptionCn">- {{ item.thirdPartyFeeDescriptionCn }}</span>
                  <span class="crgy9" v-if="getLanguage == 'en' && item.thirdPartyFeeDescription">- {{ item.thirdPartyFeeDescription }}</span>
                  <span v-if="$isNumberLike(item.thirdPartyFee)">({{ priceCurrencyFormat(item.thirdPartyFee, item.currency) }})</span>
                </p>
                <!-- 其他费用 -->
                <p class="fs12 mb2" v-if="item.otherFeeDescriptionCn && item.otherFeeDescription">
                  <span class="fwb green fs12 el-icon-check"></span>
                  {{ $t("creation.otherExpenses") }}
                </p>
                <p class="fs12 tof03 thirdparty">
                  <span class="crgy9" v-if="getLanguage == 'zh' && item.otherFeeDescriptionCn">- {{ item.otherFeeDescriptionCn }}</span>
                  <span class="crgy9" v-if="getLanguage == 'en' && item.otherFeeDescription">- {{ item.otherFeeDescription }}</span>
                  <span v-if="$isNumberLike(item.otherFee)">({{ priceCurrencyFormat(item.otherFee, item.currency) }})</span>
                </p>
              </el-card>
              <p class="el-icon-success pitch"></p>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="pt20 pb20 wdb100 fxRow">
        <el-button type="primary" @click="onSubmit" class="pl20 pr20">{{ $t("common.button.affirm") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import formatMixin from "@/mixins/formatMixin";
import priceCountMixin from "@/mixins/priceCountMixin";
import { mapGetters } from "vuex";
export default {
  mixins: [formatMixin, priceCountMixin],
  props: {
    country: {
      type: String,
      default: "",
    },
    businessType: {
      type: String,
      default: "",
    },
    serviceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      requiredServiceCodeList: [], // 必选服务code列表
      selectedServiceIdList: [], // 选中服务id列表
    };
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
    ...mapGetters("constant", ["getServiceCodeMap"]),
  },
  methods: {
    // 初始化
    init(selectedList) {
      // 设置选中服务id列表
      const selectedListCopy = JSON.parse(JSON.stringify(selectedList));
      this.selectedServiceIdList = selectedListCopy.map(item => item.id);
      // 设置必选服务code列表
      const mapObj = this.getServiceCodeMap(this.country, this.businessType);
      this.requiredServiceCodeList = mapObj?.requiredServiceCodeList || [];
      // 显示弹窗
      this.visible = true;
    },
    // 点击服务卡片
    clickHandle(item) {
      // 必选服务禁止点击
      if (this.requiredServiceCodeList.includes(item.serviceCode)) return;
      const mapObj = this.getServiceCodeMap(this.country, this.businessType);
      // 公司注册地址服务code列表
      const companyRegistrationAddressServiceCodeList = mapObj?.companyRegistrationAddressServiceCodeList || [];
      // 名义董事服务code列表
      const nomineeDirectorServiceCodeList = mapObj?.nomineeDirectorServiceCodeList || [];
      // 公司秘书服务-基本服务code列表
      const companySecretaryServiceCodeList = mapObj?.companySecretaryServiceCodeList || [];
      // 获取当前点击项在选中项中的索引
      const selectedIdx = this.selectedServiceIdList.indexOf(item.id);
      // 如果选中项中包含当前点击项，删除当前点击项
      if (selectedIdx != -1) {
        this.selectedServiceIdList.splice(selectedIdx, 1);
        // 业务类型为公司设立时
        if (this.businessType === "COMPANY_INCORPORATION") {
          // 如果点击【公司秘书服务】
          if (companySecretaryServiceCodeList.includes(item.serviceCode)) {
            // 获取【公司注册地址服务】或【名义董事服务】的id，并将id从选中项中删除
            const addressList = this.serviceList.filter(
              ele => companyRegistrationAddressServiceCodeList.includes(ele.serviceCode) || nomineeDirectorServiceCodeList.includes(ele.serviceCode),
            );
            addressList.forEach(data => {
              const idx = this.selectedServiceIdList.indexOf(data.id);
              if (data.id && idx != -1) this.selectedServiceIdList.splice(idx, 1);
            });
          }
        }
      } else {
        this.selectedServiceIdList.push(item.id);
        // 业务类型为公司设立时
        if (this.businessType === "COMPANY_INCORPORATION") {
          // 如果点击【公司注册地址服务】或【名义董事服务】
          if (companyRegistrationAddressServiceCodeList.includes(item.serviceCode) || nomineeDirectorServiceCodeList.includes(item.serviceCode)) {
            // 获取【公司秘书服务】的id，并将id添加到选中项中
            const secretarialList = this.serviceList.filter(ele => companySecretaryServiceCodeList.includes(ele.serviceCode));
            secretarialList.forEach(data => {
              if (data.id && !this.selectedServiceIdList.includes(data.id)) this.selectedServiceIdList.push(data.id);
            });
          }
        }
      }
    },
    // 提交表单
    onSubmit() {
      const selectedServiceList = this.serviceList.filter(item => this.selectedServiceIdList.includes(item.id));
      this.$emit("update", selectedServiceList);
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.serviceWrap {
  p {
    line-height: 1.5;
  }

  ::v-deep {
    .el-dialog__header {
      padding: 20px 20px 0;
      line-height: 1.5;
    }

    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
    }
  }

  .bodyWrap {
    min-height: 500px;
  }

  .title {
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 4px;
    font-weight: bold;
  }

  .upgradePrice {
    font-size: 16px;
    color: #409eff;
    line-height: 1em;
    margin-bottom: 8px;
  }

  .describe {
    font-size: 12px;
    color: #999;
    margin-bottom: 4px;
  }
}

.aloneWrap {
  position: relative;
  margin-bottom: 20px;
  cursor: pointer;

  .pitch {
    display: none;
    position: absolute;
    bottom: 4px;
    right: 14px;
    color: #409eff;
    font-size: 16px;
    z-index: 100;
  }
}

.aloneActive {
  .el-card {
    border-color: #409eff;
  }
  .pitch {
    display: block;
  }
}
</style>
